import { type Till } from "~/api/tills/types";

type DiningOptionsInput = {
  inputId: string;
  options: string[];
};

/**
 * Get the first 4 dining options from the first pre-checkout text input.
 * @param preCheckoutTextInputs - The pre-checkout text inputs from the till.
 * @returns The input ID and dining options, or undefined if no input is found.
 */
export function getDiningOptionsInput(
  preCheckoutTextInputs: Till["preCheckoutTextInputs"]
): DiningOptionsInput | null {
  if (!preCheckoutTextInputs || preCheckoutTextInputs.length === 0) {
    return null;
  }

  const firstInput = preCheckoutTextInputs[0];
  const inputId = firstInput.key;

  if (!inputId || firstInput.type !== "select" || !firstInput.options) {
    return null;
  }

  const options = firstInput.options.slice(0, 4);

  if (options.length === 0) {
    return null;
  }

  return { inputId, options };
}
